import { render, staticRenderFns } from "./WechatPay.vue?vue&type=template&id=5c294f62&"
import script from "./WechatPay.vue?vue&type=script&lang=js&"
export * from "./WechatPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports